import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useCreativeInput } from '../hooks';

const JSTracker = props => {
  const [creative, setCreative] = useState(props.creative);
  const [errorMessage, setErrorMessage] = useState('');

  const creativeInputProps = useCreativeInput(
    ['jsTracker'],
    creative,
    setCreative,
    props.CreativeService
  );

  useEffect(
    function validate() {
      if (!creative || creative.jsTracker == undefined) {
        return;
      }

      if (
        creative.jsTracker.match(
          /^$|<script (.*\s)?src=("(.|\s)*"|'(.|\s)*')><\/script>/i
        )
      ) {
        setErrorMessage('');
      } else {
        setErrorMessage('JS Tracker must match <script src=""></script>');
      }
    },
    [creative.jsTracker]
  );

  return (
    <div className="input-with-label-inside">
      <label htmlFor="js-tracker">Third Party JS</label>
      <textarea
        {...creativeInputProps.jsTrackerProps}
        id="js-tracker"
        data-testid="js-tracker-input"
        className={`form control ${errorMessage ? 'error' : ''}`}
        placeholder='<script src=""></script>'
      />
      {errorMessage && (
        <small data-testid="js-tracker-error" className="error">
          {errorMessage}
        </small>
      )}
    </div>
  );
};

JSTracker.propTypes = {
  CreativeService: PropTypes.object.isRequired,
  creative: PropTypes.object.isRequired
};

export default JSTracker;
